import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const CreditScoreCheck = (props) => {
  return (
    <Svg
      width={48}
      height={48}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#a)">
        <Rect width={48} height={48} rx={8} fill="#F2F7FF" />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m13.842 23.461 3.083 4.111a11.377 11.377 0 0 0-3.71 7.195h-5.16c0-4.214 2.786-8.9 5.787-11.306Z"
          fill="url(#b)"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m33.113 21.981-3.083 4.111a11.388 11.388 0 0 0-11.142 0l-3.083-4.11a16.444 16.444 0 0 1 17.308 0Z"
          fill="url(#c)"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.944 34.715h-5.139a11.419 11.419 0 0 0-3.7-7.194l3.022-4.111a16.217 16.217 0 0 1 5.817 11.305Z"
          fill="url(#d)"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.749 33.698c.894-.524 3.484-.75 5.786-.802-1.192 1.984-2.682 4.111-3.587 4.625a2.21 2.21 0 0 1-3.011-.802 2.24 2.24 0 0 1 .812-3.021Z"
          fill="#3982DD"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.945 37.254a16.444 16.444 0 0 1-32.89 0h6.27A1.264 1.264 0 0 0 15.641 36a8.85 8.85 0 0 1 15.714-5.612c-1.747 0-6.814-.061-8.86 1.13a4.738 4.738 0 0 0 2.365 8.85 4.842 4.842 0 0 0 2.364-.637c2.055-1.213 4.635-5.684 5.447-7.195A8.942 8.942 0 0 1 33.36 36a1.252 1.252 0 0 0 1.264 1.264l6.32-.01Z"
          fill="url(#e)"
        />
      </G>
      <Defs>
        <RadialGradient
          id="c"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-15.21608 6.16005 -3.74276 -9.24507 30.375 19.912)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="e"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-27.77071 24.06847 -22.1552 -25.56314 38.442 28.852)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <LinearGradient
          id="b"
          x1={12.491}
          y1={23.461}
          x2={12.491}
          y2={34.767}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F78D76" />
          <Stop offset={1} stopColor="#FFDBCC" />
        </LinearGradient>
        <LinearGradient
          id="d"
          x1={30.5}
          y1={27.5}
          x2={39.5}
          y2={34.5}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#78AD4E" />
          <Stop offset={0} stopColor="#BDE6AA" />
          <Stop offset={0.792} stopColor="#6FBA54" stopOpacity={0.99} />
        </LinearGradient>
        <ClipPath id="a">
          <Rect width={48} height={48} rx={8} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default CreditScoreCheck
